<div class="field-map-container">
  <canvas #canvas width="100" height="80"></canvas>
</div>
